import React from 'react';
import { CloudCheckIcon, CloudUploadIcon } from 'lucide-react';
import { SyncState } from '../types/activity';
interface SyncTagProps {
  sync: SyncState;
}
export function SyncTag({
  sync
}: SyncTagProps) {
  if (sync === 'pending') {
    return <span className="inline-flex items-center gap-1 text-xs font-semibold text-info-ink" data-id="element-964" data-mp="sx8vn0cq01cv">
        <CloudUploadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-965" data-mp="xxn42ji8hdbf" />
        Čaka na sinhronizacijo
      </span>;
  }
  return <span className="inline-flex items-center gap-1 text-xs font-semibold text-muted" data-id="element-966" data-mp="59hkw16tvwdp">
      <CloudCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-967" data-mp="a8u66hi1wve6" />
      Shranjeno
    </span>;
}